import { render, staticRenderFns } from "./CreateAlternatePrintable.vue?vue&type=template&id=7031ddba&scoped=true&"
import script from "./CreateAlternatePrintable.vue?vue&type=script&lang=js&"
export * from "./CreateAlternatePrintable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7031ddba",
  null
  
)

export default component.exports